if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.formId = this.dataset.formId;
        this.bar = this.querySelector('.sticky-add-to-cart__bar');
        this.button = this.querySelector('.sticky-add-to-cart__button');
        this.isStuck = false;
        this.hiddenByFooter = false;

        this.button?.addEventListener('click', this.handleClick.bind(this));

        this.setupObservers();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.buyButtonsObserver?.disconnect();
        this.footerObserver?.disconnect();
        if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      }

      setupObservers() {
        const buyButtonsBlock = document.getElementById(`ProductBuyButtons-${this.sectionId}`);
        if (!buyButtonsBlock) return;

        const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');

        this.buyButtonsObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;

          if (!entry.isIntersecting && !this.isStuck) {
            const rect = entry.target.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top < 0) {
              this.show();
            }
          } else if (entry.isIntersecting && this.isStuck) {
            this.hiddenByFooter = false;
            this.hide();
          }
        });
        this.buyButtonsObserver.observe(buyButtonsBlock);

        if (footer) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry) return;

              if (entry.isIntersecting && this.isStuck) {
                this.hiddenByFooter = true;
                this.hide();
              } else if (!entry.isIntersecting && this.hiddenByFooter) {
                const rect = buyButtonsBlock.getBoundingClientRect();
                if (rect.bottom < 0 || rect.top < 0) {
                  this.hiddenByFooter = false;
                  this.show();
                }
              }
            },
            { rootMargin: '200px 0px 0px 0px' }
          );
          this.footerObserver.observe(footer);
        }
      }

      show() {
        this.isStuck = true;
        this.bar.dataset.stuck = 'true';
      }

      hide() {
        this.isStuck = false;
        this.bar.dataset.stuck = 'false';
      }

      handleClick() {
        const realButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (realButton && realButton.getAttribute('aria-disabled') !== 'true' && !realButton.disabled) {
          realButton.click();
        }
      }

      handleVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;
        const { html, variant } = event.data;

        const newPrice = html.querySelector(`#price-${this.sectionId}`);
        const currentPrice = this.querySelector('.sticky-add-to-cart__price');
        if (newPrice && currentPrice) currentPrice.innerHTML = newPrice.innerHTML;

        const variantLabel = this.querySelector('.sticky-add-to-cart__variant');
        if (variantLabel && variant) variantLabel.textContent = variant.title;

        const image = variant && variant.featured_image ? variant.featured_image.src : null;
        const imgEl = this.querySelector('.sticky-add-to-cart__image img');
        if (image && imgEl) imgEl.src = image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');

        this.dataset.variantAvailable = variant ? String(variant.available) : 'false';

        if (this.button) {
          this.button.disabled = !variant || !variant.available;
          this.button.textContent = !variant
            ? window.variantStrings?.unavailable || 'Unavailable'
            : !variant.available
              ? window.variantStrings?.soldOut || 'Sold out'
              : window.variantStrings?.addToCart || 'Add to cart';
        }
      }
    }
  );
}
